var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2741 5.59418C16.5451 5.80789 16.5916 6.20087 16.3779 6.47194L9.41631 15.302C9.30634 15.4415 9.14223 15.5276 8.96497 15.5388C8.78771 15.55 8.61405 15.4853 8.48738 15.3607L3.67516 10.6306C3.42899 10.3887 3.42559 9.99294 3.66755 9.74677C3.90952 9.5006 4.30524 9.4972 4.5514 9.73917L8.86638 13.9805L15.3963 5.69803C15.61 5.42697 16.003 5.38047 16.2741 5.59418Z",
    fill: "#353C43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4cbd3a168383d44c12a0ab746be430b3.svg";
export { ForwardRef as ReactComponent };